export default {
  methods: {
    togglePassword() {
      this.inputType = this.isPassword ? "text" : "password";
    },

    disablePaste(event) {
      event.preventDefault();
    },

    verificarSenha(senha) {
      this.tamanhoSenha = senha.length < 10 || senha.length > 20;
      this.minusculaSenha = !/[a-z]/.test(senha);
      this.maiusculaSenha = !/[A-Z]/.test(senha);
      this.numeroSenha = !/\d/.test(senha);
      this.simbolosNaoPermitidosSenha =
          /[@#&%,+ ]/.test(senha) || senha === ""; 
      this.simbolosPermitidosSenha =
          !/[!?¨\-*]/.test(senha) || senha === "";
      this.validacaoSenha = !(
          this.tamanhoSenha ||
          this.minusculaSenha ||
          this.maiusculaSenha ||
          this.numeroSenha ||
          this.simbolosPermitidosSenha ||
          this.simbolosNaoPermitidosSenha
      );
  },
  

    verificarSenhaIgual() {
      this.validacaoSenhaIgual =
        this.senhaConfirmacao === this.senhaNova &&
        this.senhaConfirmacao !== "" &&
        this.validacaoSenha === true;
    },

    async redefinirSenha() {
      var dados = {
        cd_token: this.emailToken,
        sq_usuario: this.sq_usuario,
        senha_atual: this.senhaAtual,
        senha_nova: this.senhaNova,
        usuario_logado: this.usuarioLogado,
      };

      try {
        const trocaSenha = await this.$http.post("api/auth/redefinirSenha", dados);
        return trocaSenha;
      } catch (error) {
        this.loadingRedefinir = false;
        this.$tools.alerta(error.response.data.message, "error");
      }
    },

    logoutUser() {
      this.$store
        .dispatch("logout")
        .then(() => this.$router.push("/login"))
        .catch(() => this.$router.push("/login"));
    },
  },
}